module.exports = __webpack_public_path__ + "static/media/live-cover.5fe7aa85.jpg";